import { withFieldHint } from "@/src/components/HighOrderComponents";
import { AutoNumberField } from "./AutoNumberField";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import { useHandleApiCall } from "@/src/components/pages/StepPage/components/apiCalls/useHandleApiCall";

import { useFieldDebouncedCallback } from "@/src/hooks/useFieldDebouncedCallback";
import {apiCallsModalStore} from "@/src/components/pages/StepPage/components/apiCalls/modalStore";
import {ApiCallModalType} from "@/src/components/pages/StepPage/components/apiCalls/types";
import {ModalErrorTypes} from "@/src/shared/const";
import {useFieldsReset} from "@/src/components/pages/StepPage/components/apiCalls/Modals/AutoSearch/Success";
import {FlowCodes} from "@/src/components/pages/StepPage/components/apiCalls/contants";

const AutoNumberFieldWithHint = withFieldHint(AutoNumberField);

// For Green Card, these fields are disabled (via a CMS blockly rule) once MTSBU returns a
// matched vehicle for the entered plate number. They must be reset to null here so that rule
// re-evaluates and re-enables manual input when the MTSBU search errors or finds no vehicle.
const GREEN_CARD_MTSBU_RESET_FIELDS = [
  "seatsCountFromMTSBU",
  "totalWeightFromMTSBU",
  "vehicleKindFromMTSBU",
];

export function AutoNumberInput(props: any) {
  const { hint, name, apiCalls } = props;
  const hints = hint?.hintsList;
  const form = useFormContext();
  const {
    control,
    formState: { isDirty },
    trigger,
    getValues,
  } = form;

  const debouncedUpdateField = useFieldDebouncedCallback(name);

  const [isLoading, setIsLoading] = useState(false);

  const { handleApiCallWithSideEffects } = useHandleApiCall();
  const resetFields = useFieldsReset();

  const handleApiCalls = async () => {
    const formValues = getValues();
    const isValid = await trigger(name);

    if (isValid && isDirty && apiCalls?.length) {
      setIsLoading(true);
      // await Promise.allSettled(
      //   apiCalls.map(({ params }) => handleApiCall(formValues, params)),
      // );

      handleApiCallWithSideEffects(formValues, apiCalls[0].params)
        ?.catch((e) => {
            if (e?.response?.data?.error && e?.response?.data?.error === ModalErrorTypes.NOT_ALLOWED) {
                apiCallsModalStore
                    .getState()
                    .open(ApiCallModalType.AUTO_SEARCH_FORBIDDEN, {
                        plateNumber: formValues["plateNumber"] || "",
                    })
            }
          if (formValues?.flowCode === FlowCodes.GREEN_CARD) {
            resetFields(GREEN_CARD_MTSBU_RESET_FIELDS);
          }
          console.log(e);
        })
        ?.finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <>
      <AutoNumberFieldWithHint
        {...props}
        placeholder="AA 0000 AA"
        hints={hints}
        control={control}
        name={name}
        disabled={isLoading || props.disabled}
        loading={isLoading}
        onChange={(e) => {
          if (!e?.currentTarget?.closest('[role="dialog"]')) {
            debouncedUpdateField(e.target.value);
          }
        }}
        onBlur={handleApiCalls}
      />
    </>
  );
}
